<template>
    <span dir="ltr" style="white-space: nowrap;  direction: ltr; unicode-bidi: bidi-override;">
        <template v-if="settings.position === 'left'">
            <template v-if="settings.icon">
                <v-icon v-if="!hideCurrency" style="color: inherit; font-size: inherit; margin-top: -2px;">
                    {{ settings.icon }}
                </v-icon>
                {{ formattedValue }}
            </template>

            <template v-else-if="settings.symbol">
                <small v-if="!hideCurrency">{{ settings.symbol }}&nbsp;</small>
                {{ formattedValue }}
            </template>

            <template v-else>
                <small v-if="!hideCurrency">{{ code }} </small>
                {{ formattedValue }}
            </template>
        </template>

        <template v-if="settings.position === 'right'">
            <template v-if="settings.icon">
                {{ formattedValue }}
                <v-icon v-if="!hideCurrency" style="color: inherit; font-size: inherit; margin-top: -2px;">
                    {{ settings.icon }}
                </v-icon>
            </template>

            <template v-else-if="settings.symbol">
                {{ formattedValue }}
                <small v-if="!hideCurrency">&nbsp;{{ settings.symbol }}</small>
            </template>

            <template v-else>
                {{ formattedValue }}
                <small v-if="!hideCurrency"> {{ code }}</small>
            </template>
        </template>
    </span>
</template>

<script>
import {CurrencySettings} from "../../extensions/services/currency-settings";

export default {
    props: {
        value: {
            type: Number,
            default: () => 0,
        },
        currency: {
            type: String,
            default: () => "",
        },
        hideCurrency: {
            type: Boolean,
            default: () => false,
        },
    },
    created() {
        if (this.currency !== "") {
            return;
        }

        this.currency = this.$store.state.currency;
    },
    computed: {
        code() {
            if (typeof this.currency !== "string" || this.currency.length !== 3) {
                // eslint-disable-next-line vue/no-side-effects-in-computed-properties
                this.currency = this.$store.state.currency;
            }

            if (
                this.$store.getters.localSettings("currencies") &&
                typeof this.$store.getters.localSettings("currencies")[this.currency] !== "undefined"
            ) {
                return this.$store.getters.localSettings("currencies")[this.currency].display;
            }

            return this.currency;
        },
        formattedValue() {
            let n = this.value;

            n = Number(parseFloat(n).toFixed(4) + 0);

            return this.addThousandSeparator(this.handleDecimals(n));
        },
        settings() {
            return CurrencySettings[this.currency] || CurrencySettings["default"];
        },
    },
    methods: {
        addThousandSeparator(n) {
            const nStr = n.toString();
            const remainder = nStr.length % 3;

            let formatted = (nStr.substr(0, remainder) + nStr.substr(remainder).replace(/(\d{3})/g, ' ' + "$1")).trim();

            if (formatted[0] === ' ') {
                formatted = formatted.substr(1);
            }

            console.log('formatted', formatted);

            return formatted;
        },
        handleDecimals(n) {
            return Number.isInteger(n) ? parseInt(n) : n.toFixed(this.settings.decimals);
        },
    },
};
</script>
